<template>
  <div
    ref="wrapper"
    class="container mx-auto px-2 gap-x-6 grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 py-5"
    :class="isB2b ? 'auto-rows-[30px]' : 'auto-rows-[37px]'"
  >
    <ul
      v-for="item in visibleChildren"
      :key="item.name"
      :style="`grid-row-end: span ${getVisibleLinks(item).length + 2}`"
      class="block list-none"
      role="menu"
    >
      <li v-if="hasColumnHeaderText(item)" role="none" :class="{'h-8': isB2b}">
        <h2 class="font-heading font-bold nav-section-title relative mb-1 text-sm">
          <a
            v-if="hasColumnHeaderLink(item)"
            class="hover:underline nav__menu-item block"
            role="menuitem"
            :href="composeLink(item.url.url)"
            :target="setTarget(item.url.target)"
            tabindex="-1"
            @keydown.prevent.right="focusNextColumn"
            @keydown.prevent.left="
              (e) => {
                !isCompactView ? focusPreviousColumn(e) : focusParentTier();
              }
            "
            @keydown.prevent.down="focusNextElement"
            @keydown.prevent.up="focusPreviousElement"
            v-html="item.url.linkName"
          />
          <span v-else v-html="item.url.linkName" />
        </h2>
      </li>
      <li v-for="link in getVisibleLinks(item)" :key="link.label" role="none">
        <a
          :href="composeLink(link.url)"
          :target="setTarget(link.target)"
          role="menuitem"
          class="nav__menu-item text-sm hover:underline flex items-center"
          :class="isB2b ? 'leading-normal py-25 mt-px' : 'py-1'"
          tabindex="-1"
          :qaid="link.uid"
          @keydown.prevent.right="focusNextColumn"
          @keydown.prevent.left="
            (e) => {
              !isCompactView ? focusPreviousColumn(e) : focusParentTier();
            }
          "
          @keydown.prevent.down="focusNextElement"
          @keydown.prevent.up="focusPreviousElement"
        >
          <pdl-icon v-if="hasBoltIcon(link)" name="Bolt" size="18" class="-ml-25" />
          <span v-html="link.linkName" />
        </a>
      </li>
    </ul>
    <ul v-if="visibleEditorialCards" :style="`grid-row-end: span ${isCompactView ? 9 : 7}`">
      <li v-for="card in visibleEditorialCards" :key="card.ctaLinks.uid" class="pb-2">
        <NavCard
          :card="card"
          :down-function="focusNextElement"
          :up-function="focusPreviousElement"
          :right-function="focusNextElement"
          :left-function="
            (e) => {
              !isCompactView ? focusPreviousElement(e) : focusParentTier();
            }
          "
        />
      </li>
    </ul>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import NavCard from './components/NavCard.vue';
import {PdlIcon} from '@pedal/pdl-icon';
import links from '@/navigation/mixins/links.js';
export default {
  name: 'NavB2bLayout',
  components: {
    NavCard,
    PdlIcon,
  },
  mixins: [links],
  inject: ['focusParentTier', 'focusNextMenuItem', 'focusPreviousMenuItem'],
  props: {
    isB2b: {
      type: Boolean,
      default: false,
    },
    navItemData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('global', ['isCompactView']),
    visibleChildren() {
      return (
        this.navItemData?.children?.filter(
          (item) => item.url?.hasVisibleProducts !== false && item?.visible !== false && item?.links?.length > 0
        ) || []
      );
    },
    visibleEditorialCards() {
      return (
        this.navItemData?.categoryCardEditorialComponentData?.filter(
          (item) => item.ctaLinks?.[0]?.hasVisibleProducts !== false && item.ctaLinks?.[0]?.visible !== false
        ) || []
      );
    },
    navElements() {
      let els = [];
      this.$refs.wrapper.querySelectorAll('.nav__menu-item').forEach((el) => {
        els.push(el);
      });
      return els;
    },
  },
  methods: {
    focusPreviousColumn(e) {
      const newFocusedItem = e.target.parentNode.parentNode.previousElementSibling
        ? e.target.parentNode.parentNode.previousElementSibling?.querySelector('.nav__menu-item')
        : e.target.parentNode.parentNode.parentNode.lastElementChild.querySelector('.nav__menu-item');
      e.target.tabIndex = -1;
      newFocusedItem.focus();
    },
    focusNextColumn(e) {
      const newFocusedItem = e.target.parentNode.parentNode.nextElementSibling
        ? e.target.parentNode.parentNode.nextElementSibling?.querySelector('.nav__menu-item')
        : e.target.parentNode.parentNode.parentNode.firstElementChild.querySelector('.nav__menu-item');
      e.target.tabIndex = -1;
      newFocusedItem.focus();
    },

    focusNextElement(e) {
      const elIndex = this.navElements.indexOf(e.target);
      e.target.tabIndex = -1;
      const targetIndex = elIndex < this.navElements.length - 1 ? elIndex + 1 : 0;

      this.navElements[targetIndex].tabIndex = 0;
      this.navElements[targetIndex].focus();
    },
    focusPreviousElement(e) {
      const elIndex = this.navElements.indexOf(e.target);
      if (elIndex === 0 && !this.isCompactView) {
        this.focusParentTier(e);
        return;
      }
      e.target.tabIndex = -1;
      const targetIndex = elIndex > 0 ? elIndex - 1 : this.navElements.length - 1;
      this.navElements[targetIndex].tabIndex = 0;
      this.navElements[targetIndex].focus();
    },
    hasColumnHeaderText(item) {
      return !!item?.url?.linkName?.length > 0;
    },
    hasColumnHeaderLink(item) {
      return !!item?.url?.url?.length > 0;
    },
    getVisibleLinks(item) {
      return (
        item?.links?.filter(
          (link) => link?.hasVisibleProducts !== false && link?.visible !== false && link?.url?.length > 0
        ) || []
      );
    },
    hasBoltIcon(item) {
      return !!(item?.linkNavMenuIconName === 'LightningBolt' && this.isB2b);
    },
  },
};
</script>
